// Path: ./src/app/components/PermissionSelectTable/styled.ts
import styled from "styled-components";
import { TextInputField } from "../../../utils/commonStyledComponents/commonStyled";

export const TableList = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
`;

export const InputTextField = styled(TextInputField)`
  padding: 5px;
  width: 248px;
`;
export const Wrapper = styled.div``;

interface TableProps {
  withInputField:
    | {
        isChecked: boolean;
        title: string;
        includeTextInput?: boolean | undefined;
        onClick?: (() => void) | undefined;
      }
    | undefined;
}
export const Table = styled.div<TableProps>`
  /* border: 3px solid #bcbcbc; */
  height: 100%;
  width: ${(props) => (props.withInputField ? "100%" : "240px")};
`;

export const TableHead = styled.div`
  background-color: #e5e5e5;
  display: flex;
  justify-content: start;
  border-bottom: 3px solid #bcbcbc;
  padding-left: 14px;
`;

export const TableBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  padding-left: 14px;
  padding-right: 14px;
`;
